import React, { useState, useEffect } from 'react';
import styles from './Chatbot.module.scss';
import ChatButton from './ChatButton';
import DesktopChat from './DesktopChat';
import MobileChat from './MobileChat';

const ChatInterface: React.FC = () => {
    const maxViewPortWidthMobileView = 600;
    const [isChatVisible, setIsChatVisible] = useState<boolean>(false);
    const [showTooltip, setShowTooltip] = useState<boolean>(true);
    const [isMobileView, setIsMobileView] = useState<boolean>(window.innerWidth <= maxViewPortWidthMobileView);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= maxViewPortWidthMobileView);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => setShowTooltip(false), 5000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={styles.chatContainer}>
            {!isChatVisible && <ChatButton showTooltip={showTooltip} setIsChatVisible={setIsChatVisible} />}
            {isChatVisible &&
                (isMobileView ? <MobileChat setIsChatVisible={setIsChatVisible} /> : <DesktopChat setIsChatVisible={setIsChatVisible} />)}
        </div>
    );
};

export default ChatInterface;
